import { render } from "./dictionary.vue?vue&type=template&id=458610f8&scoped=true"
import script from "./dictionary.vue?vue&type=script&lang=js"
export * from "./dictionary.vue?vue&type=script&lang=js"

import "./dictionary.vue?vue&type=style&index=0&id=458610f8&lang=less&scoped=true"

import exportComponent from "E:\\MySite\\XuDAQMS\\xudaqms-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458610f8"]])

export default __exports__